module.exports = "/static/media/lineto-circular-book.2ac8bef0.woff";